var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWine = function SvgWine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3h11l-.7 5.1a5.3 5.3 0 0 1-3.8 4.4V19h3.3a1 1 0 1 1 0 2H7.7a1 1 0 1 1 0-2H11v-6.5a5.3 5.3 0 0 1-3.8-4.4z"
  })));
};
export default SvgWine;